import { createGlobalStyle } from 'styled-components';

export const BannersStyles = createGlobalStyle`
    .lotriver-top-banner {
        z-index: 10;

        &--rows {
            margin-top: -8px;
        }

        &:empty {
            display: none;
        }

        a img {
            width: 100%;
            object-fit: cover;
            max-width: 480px !important;

            @media (min-width: 950px) {
                max-width: none !important;
            }
        }
    }

    .lotriver-bottom-banner {
        display: none;
        width: 100%;
        margin: 0 auto;

        a img {
            width: 100%;
            max-width: 480px !important;
            object-fit: cover;
        }

        @media (max-width: 740px) {
            display: block;
        }

        &--in-list {
            width: 100%;
        }

        &.content-banner {
            overflow: hidden;

            @media (min-width: 480px) {
                display: none;
            }
        }
    }

    .lotriver-bg-right,
    .lotriver-bg-left,
    .google-buds-bg-banner,
    .google-buds-bg-banner-left {
      display: none;
      z-index: 1 !important;

      @media (min-width: 1200px) {
        display: block;
      }
    }

    .google-buds-bg-banner, .google-buds-bg-banner-left {
      position: fixed;
      top: 74px;
      width: calc((100vw - 1000px) / 2);
      height: calc(100vh - 74px);
      overflow: hidden;
    }

    .google-buds-bg-banner {
      right: 0;
    }

    .google-buds-bg-banner-left {
      left: 0;
    }

    .google-buds-banner-scammer, .google-buds-bottom-banner, .google-buds-top-banner {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        max-width: 320px;
        max-height: 100px;
        margin: 0 auto;

      @media (min-width: 950px) {
        max-width: none !important;
      }
    }

    .google-buds-banner {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 220px;
        overflow: hidden;
    }
`;
